import React, { Component } from 'react';
import { Form, Button, Input } from 'reactstrap';
import _ from 'lodash';
import intl from 'react-intl-universal';
import Axios from '../../config/Axios';
import url from '../../config/Url';
import imgfGroup from '../../assets/img/group.svg';
import PageClean from '../default-v2/PageClean';
import imgfNoPic from '../../assets/img/nopic.svg';
import OutsideHandlerClick from '../../components/OutsideHandlerClick';
import { Alert } from '../../components/Alert';
import './styles/documentedit.scss';
import Select from 'react-select';
import DateLimitation from '../../components/DateLimitation';
import checkTime from '../../components/CheckDate';
import { can, checkModule } from '../../config/Permissions';
import EncodedLocalStorage from '../../config/EncodedLocalStorage';
import TreeViewLayer from '../../components/TreeViewLayer';
import authorizedFolders from '../../actions/ActionAuthorizedFolders';
import getNewDocument from '../../actions/ActionDocument';


const oLocalStorage = new EncodedLocalStorage();
const nUserId = oLocalStorage.get('nUserId');
class DocumentEdit extends Component {
  constructor(oProps) {
    super(oProps);
    this.alertWrapper = React.createRef();

    const { router } = oProps;
    const params = router ? router.params : {};
    this.state = {
      bLoading: true,
      nDocumentId: params && params.nDocumentId ? params.nDocumentId : oProps.oDocument.doc_nid,
      cNameSearch1: undefined,
      cNameSearch2: undefined,
      aCreateTeams: [],
      aCreateUsers: [],
      oDocument: [],
      aTeams: [],
      aSelectedDistribution: [],
      aSelectedUsers: [],
      aSelected: [],
      aAvailableList: [],
      aUsers: [],
      oVersion: [],
      bIsSend: false,
      cResponsibleName: '',
      aAvailable: [],
      bShowWarning: false,
      cSearch: '',
      aTreeViewFolders: [],
      aRequisites: [],
      aSelectedRequisites: [],
      nVerStatId: 0
    };
  }

  componentDidMount = () => {
    const { nDocumentId } = this.state;
    const { setAlert, nVerId, router } = this.props;
    const navigate = (router && router.navigate) || (() => { });
    const params = router ? router.params : {};
    checkModule(navigate, 'documents');

    Axios.get(`/document/edit/${nDocumentId}`, { params: { nVerId } })
      .then(oResponse => {
        const {
          oDocument,
          aTeams,
          aSelectedDistribution,
          oVersion,
          aSelected,
          aAvailableList,
          aSelectedUsers,
          nResponsibleId,
          nWriterId,
          nReviewerId,
          bAmResponsible,
          aSelectedRequisites,
        } = oResponse.data;

        const nVersionStatId = oVersion?.stat_nid;
        const bIsPublishedCorrect = nVersionStatId === 4;

        let aUsers = [];
        let cResponsibleName = this.getResponsible(aSelectedUsers, nResponsibleId);
        if (cResponsibleName !== undefined) {
          cResponsibleName = cResponsibleName.user_cname;
        }
        let aNewAvailableList = [...aAvailableList];


        Object.keys(aSelectedUsers).forEach(cKey => {
          aUsers.push({
            label: aSelectedUsers[cKey].user_cname,
            value: Number(aSelectedUsers[cKey].user_nid)
          });
        });

        const aNewSelectedDistribution = (aSelectedDistribution || [])
          .filter(team => team && team.team_cname && team.team_nid)
          .map(team => ({
            label: team.team_cname,
            value: Number(team.team_nid)
          }));

        const aNewTeams = aTeams.map(oTeam => ({
          label: oTeam.team_cname,
          value: oTeam.team_nid
        }));

        let j = 0;
        let n = 0;
        for (let i = 0; i < aSelected.length; i += 1) {
          j = 0;
          n = aNewAvailableList.length;
          while (j < n) {
            if (
              aSelected[i] &&
              aSelected[i].team_nid !== null &&
              aNewAvailableList[j].user_nid !== null &&
              aNewAvailableList[j].aTeamsIds.includes(aSelected[i].team_nid)
            ) {
              aNewAvailableList.splice(j, 1);
              n = aNewAvailableList.length;
            } else {
              j += 1;
            }
          }
        }

        const oBaseState = {
          bLoading: false,
          oDocument,
          aTeams: aNewTeams,
          aSelectedDistribution: aNewSelectedDistribution,
          aSelectedRequisites,
          oVersion,
          aSelectedUsers,
          nResponsibleId,
          nWriterId,
          nReviewerId,
          aSelected,
          aFilteredUsers: [...aNewAvailableList],
          aAvailableList: [...aNewAvailableList],
          cResponsibleName,
          bAmResponsible,
          aUsers,
          aAvailable: [...aAvailableList.concat(aSelected)],
          nVerStatId: oVersion.stat_nid,
          bIsPublishedVer: oVersion.stat_nid === 4,
        };

        if (!bIsPublishedCorrect) {
          Promise.all([
            getNewDocument(),
            authorizedFolders()
          ])
            .then(([oFormData, aTreeViewFolders]) => {
              const { aRequisites } = oFormData;
              const aFormattedRequisites = aRequisites || [];

              this.setState({
                ...oBaseState,
                aTreeViewFolders,
                aRequisites: aFormattedRequisites,
                aSelectedRequisites
              });
            })
            .catch(oExtraError => {
              console.warn('AC-734: Erro ao carregar dados extras:', oExtraError);
              this.setState(oBaseState);
            });
        } else {
          this.setState(oBaseState);
        }
      })
      .catch(oError => {
        this.setState({ bLoading: false });
        if (params) {
          setAlert('error', oError.aMsgErrors);
        } else {
          this.setState({
            rcmpAlertMsg: (
              <Alert type="error" isOpen onCloseAlert={() => { }}>
                {oError.aMsgErrors}
              </Alert>
            )
          });
        }
      });
  };

  handleChange = evt => {
    this.setState({ [evt.target.name]: evt.target.value });
  };

  handleChangeDoc = evt => {
    const { oDocument } = this.state;
    oDocument[evt.target.name] = evt.target.value;
    this.setState({
      oDocument
    });
  };

  handleChangeVersion = evt => {
    const { oVersion } = this.state;

    oVersion[evt.target.name] = evt.target.value;
    this.setState({
      oVersion
    });
  };

  handleChangeAccess = (evt, cPropName) => {
    const nValue = Number(evt.target.value);

    if (evt.target.checked) {
      this.setState(oPrevState => ({
        [cPropName]: [...oPrevState[cPropName], nValue]
      }));
    } else {
      this.setState(oPrevState => {
        const aNew = oPrevState[cPropName];
        const nPosition = aNew.indexOf(nValue);
        aNew.splice(nPosition, 1);
        this.setState({ [cPropName]: aNew });
      });
    }

    evt.target.closest('label').classList.toggle('selected');
  };

  handleSubmit = evt => {
    evt.preventDefault();

    const {
      oDocument,
      oVersion,
      nResponsibleId,
      nWriterId,
      nReviewerId,
      aSelected,
      aSelectedDistribution,
      bIsPublishedVer,
    } = this.state;
    const { onSuccess, match, setAlert } = this.props;


    if (!checkTime(oDocument.doc_etermunitessay, oDocument.doc_ntermessay, '2100-12-31')) {
      this.setState(
        {
          rcmpAlertMsg: (
            <Alert type="error" isOpen onCloseAlert={() => { }}>
              {intl.getHTML('warning_date_number', { cField: intl.get('Document.term_essay') })}
            </Alert>
          )
        },
        () => this.alertWrapper?.current?.scrollIntoView()
      );
      return;
    }
    if (!checkTime(oDocument.doc_etermunitreview, oDocument.doc_ntermreview, '2100-12-31')) {
      this.setState(
        {
          rcmpAlertMsg: (
            <Alert type="error" isOpen onCloseAlert={() => { }}>
              {intl.getHTML('warning_date_number', { cField: intl.get('Document.prazo_revisao') })}
            </Alert>
          )
        },
        () => this.alertWrapper?.current?.scrollIntoView()
      );
      return;
    }
    if (!checkTime(oDocument.doc_etermunitliberation, oDocument.doc_ntermliberation, '2100-12-31')) {
      this.setState(
        {
          rcmpAlertMsg: (
            <Alert type="error" isOpen onCloseAlert={() => { }}>
              {intl.getHTML('warning_date_number', { cField: intl.get('Document.prazo_liberacao') })}
            </Alert>
          )
        },
        () => this.alertWrapper?.current?.scrollIntoView()
      );
      return;
    }

    this.setState({
      bIsSend: true
    });

    if (!bIsPublishedVer) {
      const { aSelectedRequisites } = this.state;

      // Atualizar o oDocument com os novos valores (incluindo justificativa)
      const oUpdatedDocument = {
        ...oDocument,
        doc_ctitle: oDocument.doc_ctitle,
        fldr_nid: oDocument.fldr_nid,
        user_nid_writer: Number(nWriterId),
        user_nid_reviewer: Number(nReviewerId),
        user_nid_responsible: Number(nResponsibleId),
        doc_ntermessay: oDocument.doc_ntermessay,
        doc_etermunitessay: oDocument.doc_etermunitessay,
        doc_ntermliberation: oDocument.doc_ntermliberation,
        doc_etermunitliberation: oDocument.doc_etermunitliberation,
        doc_ntermreview: oDocument.doc_ntermreview,
        doc_etermunitreview: oDocument.doc_etermunitreview,
        doc_eversiontype: oDocument.doc_eversiontype,
        // AC-734: Incluir justificativa diretamente no oDocument
        ver_cjustification: oVersion.ver_cjustification,
        // AC-734: Incluir versão manual se aplicável
        ...(oDocument.doc_eversiontype === 'M' ? { ver_cnumber: oVersion.ver_cnumber } : {})
      };

      Axios.put('version/update-document', {
        nVersionId: oVersion.ver_nid,
        oDocument: oUpdatedDocument,
        aSelectedRequisites: aSelectedRequisites.map(oReq => oReq.value ? oReq.value : oReq),
        aSelectedDistribution: aSelectedDistribution.map(oDistribution =>
          oDistribution.value ? oDistribution.value : oDistribution
        ),
        aAttendedRequests: []
      })
        .then((oResponse) => {
          if (match) {
            setAlert('success', oResponse.data.cMessage || intl.get('DocumentEdit.alteracoes_sucesso'));
          } else {
            onSuccess(oResponse.data.cMessage || intl.get('DocumentEdit.alteracoes_sucesso'));
          }
          this.setState({
            bIsSend: false
          });
        })
        .catch(oError => {
          let cMessage = 'Ocorreu um erro inesperado.';

          if (oError.response && oError.response.data && oError.response.data.cMessage) {
            cMessage = oError.response.data.cMessage;
          } else if (oError.aMsgErrors) {
            cMessage = oError.aMsgErrors;
          } else if (oError.message) {
            cMessage = oError.message;
          }

          this.setState(
            {
              rcmpAlertMsg: (
                <Alert type="error" isOpen onCloseAlert={() => { }}>
                  {cMessage}
                </Alert>
              )
            },
            () => this.alertWrapper?.current?.scrollIntoView()
          );
          this.setState({
            bIsSend: false
          });
        });
    } else {
      // AC-734: Para documentos publicados, usar endpoint document/edit (apenas responsáveis e prazos)
      const oPayload = {
        nVerId: oVersion.ver_nid,
        nTermEssay: oDocument.doc_ntermessay,
        cTermUnitEssay: oDocument.doc_etermunitessay,
        nTermLiberation: oDocument.doc_ntermliberation,
        cTermUnitLiberation: oDocument.doc_etermunitliberation,
        nTermReview: oDocument.doc_ntermreview,
        cTermUnitReview: oDocument.doc_etermunitreview,
        ...(oDocument.doc_eversiontype === 'M' ? { cVersion: oVersion.ver_cnumber } : {}),
        nResponsibleId: Number(nResponsibleId),
        nWriterId: Number(nWriterId),
        nReviewerId: Number(nReviewerId),
        cVersionType: oDocument.doc_eversiontype,
        aSelected,
        aSelectedDistribution: aSelectedDistribution.map(oDistribution =>
          oDistribution.value ? oDistribution.value : oDistribution
        )
      };

      Axios.put(`document/edit/${oDocument.doc_nid}`, oPayload)
        .then(() => {
          if (match) {
            setAlert('success', intl.get('DocumentEdit.alteracoes_sucesso'));
          } else {
            onSuccess(intl.get('DocumentEdit.alteracoes_sucesso'));
          }
          this.setState({
            bIsSend: false
          });
        })
        .catch(oError => {
          let cMessage = '';

          if (oError.response.data.cMessage != null) cMessage = oError.response.data.cMessage;
          else cMessage = oError.aMsgErrors;

          this.setState(
            {
              rcmpAlertMsg: (
                <Alert type="error" isOpen onCloseAlert={() => { }}>
                  {cMessage}
                </Alert>
              )
            },
            () => this.alertWrapper?.current?.scrollIntoView()
          );
          this.setState({
            bIsSend: false
          });
        });
    }
  };

  handleChangeCustom = (elSelectedOption, cType) => {
    this.setState({ [cType]: elSelectedOption.value });
  };

  handleChangeCustomMult = (elSelectedOption, cType) => {
    this.setState({
      [cType]: elSelectedOption.map(oOpt => oOpt.value)
    });
  };

  renderUsers = aUsers => {
    const rcmpUsers = aUsers.map(oUser => (
      <option key={oUser.user_nid} value={oUser.user_nid}>
        {oUser.user_cname}
      </option>
    ));
    return <>{rcmpUsers}</>;
  };

  onFocusSearch = () => {
    this.setState({ focused: true });
  };

  filterList = evtChange => {
    evtChange.preventDefault();

    this.setState({ focused: true });

    this.processFilterList(evtChange.target.value);
  };

  processFilterList = cSearchText => {
    const { aAvailableList } = this.state;

    let aUpdated = aAvailableList;

    aUpdated = aUpdated.filter(oItem => {
      return oItem.user_cname.toLowerCase().includes(cSearchText.toLowerCase());
    });

    this.setState({
      aFilteredUsers: aUpdated,
      cSearch: cSearchText
    });
  };

  addUser = oUser => {
    const { aAvailableList, aSelected } = this.state;
    let aNewaAvailableList = [...aAvailableList];

    if (oUser && oUser.team_nid !== null) {
      let aNewSelectedList = [...aSelected];
      let nIndex = -1;
      let aUser = [];
      let bShowWarning = false;

      aUser = this.getUsersRelatedToTeam(oUser.team_nid);

      for (let i = 0; i < aUser.length; i += 1) {
        nIndex = aNewaAvailableList.findIndex(oFilterItem => aUser[i].user_nid === oFilterItem.user_nid);
        if (nIndex !== -1) {
          aNewaAvailableList.splice(nIndex, 1);
        }
        nIndex = aNewSelectedList.findIndex(oSelectedItem => aUser[i].user_nid === oSelectedItem.user_nid);
        if (nIndex !== -1) {
          aNewSelectedList.splice(nIndex, 1);
          bShowWarning = true;
        }
      }

      nIndex = aNewaAvailableList.findIndex(oFilterItem => oUser.team_nid === oFilterItem.team_nid);
      aNewaAvailableList.splice(nIndex, 1);

      this.setState(
        {
          aAvailableList: [...aNewaAvailableList],
          aSelected: [...aNewSelectedList, oUser],
          bShowWarning
        },
        () => {
          this.processFilterList(this.state.cSearch);
        }
      );
    } else {
      const nIndex = aNewaAvailableList.findIndex(oFilterItem => oUser.user_nid === oFilterItem.user_nid);
      aNewaAvailableList.splice(nIndex, 1);
      this.setState(
        {
          aAvailableList: [...aNewaAvailableList],
          aSelected: [...aSelected, oUser]
        },
        () => {
          this.processFilterList(this.state.cSearch);
        }
      );
    }
  };

  removeUser = oUser => {
    const { aSelected, aAvailableList } = this.state;

    if (oUser && oUser.team_nid !== null) {
      let aNewAvailableList = [...aAvailableList];
      let aUser = [];

      aUser = this.getUsersRelatedToTeam(oUser.team_nid);

      aNewAvailableList = aNewAvailableList.concat(aUser);

      this.setState(
        {
          aSelected: aSelected.filter(oActualUser => oActualUser.team_nid !== oUser.team_nid),
          aAvailableList: [...aNewAvailableList, oUser],
          bShowWarning: false
        },
        () => {
          this.processFilterList(this.state.cSearch);
        }
      );
    } else {
      this.setState(
        {
          aSelected: aSelected.filter(oActualUser => oActualUser.user_nid !== oUser.user_nid),
          aAvailableList: [...aAvailableList, oUser]
        },
        () => {
          this.processFilterList(this.state.cSearch);
        }
      );
    }
  };

  getUsersRelatedToTeam = nTeamId => {
    const { aAvailable } = this.state;
    return aAvailable.filter(oAvailableItem => {
      if (oAvailableItem && oAvailableItem.nUserId !== null && oAvailableItem.aTeamsIds.includes(nTeamId)) {
        return true;
      }
      return false;
    });
  };

  getListImageSource = oItem => {
    let cStr = imgfGroup;
    if (oItem.user_cavatar) {
      cStr = oItem.user_cavatar
    } else if (oItem.user_nid !== null) {
      cStr = imgfNoPic;
    }
    return cStr;
  };

  renderList = aItems => {
    const { focused } = this.state;
    return (
      <OutsideHandlerClick handleClickOutside={this.closeSubmenu}>
        <div
          style={{ display: focused === true ? 'block' : 'none' }}
          className={`buscaBox ${aItems.length === 0 ? 'notfound' : ''}`}
          id="searchResult"
        >
          <ul className="list-group">
            {aItems.map(oItem => (
              <li
                key={oItem.user_nid ? `user-${oItem.user_nid}` : `team-${oItem.team_nid}`}
                className={`list-group-item ${!oItem.user_bregistered ? 'pending' : ''}`}
              >
                <img src={this.getListImageSource(oItem)} alt={oItem.user_nid !== null ? 'Usuário' : 'Equipe'} />
                <p className="infos">
                  <b>{oItem.user_cname}</b> <br /> {oItem.user_crole}
                </p>
                <span
                  role="button"
                  tabIndex="0"
                  onKeyPress={() => this.addUser(oItem)}
                  onClick={() => this.addUser(oItem)}
                  className="btn btn-primary"
                >
                  {intl.get('adicionar')}
                </span>
              </li>
            ))}
          </ul>
          {aItems.length === 0 && focused === true && (
            <div className="boxInvite">
              <p>{intl.get('DocumentEdit.sem_usuarios_equipes')}</p>
            </div>
          )}
        </div>
      </OutsideHandlerClick>
    );
  };

  closeSubmenu = (evt, elWrapperRef) => {
    const element = elWrapperRef;
    if (element.getElementsByClassName('buscaBox')[0]) {
      element.getElementsByClassName('buscaBox')[0].style = 'display: none';
      this.setState({ focused: false });
    }
  };

  getResponsible = (aSelectedUsers, nResponsibleId) => {
    let oUserResponsible = aSelectedUsers.find(oUserItem => oUserItem.user_nid == nResponsibleId);
    return oUserResponsible;
  };

  handleChangeDocumentResponsibles = (elSelectedOption, cResponsibleType) => {
    if (!cResponsibleType) return;

    this.setState({ [cResponsibleType]: elSelectedOption.value })
  };

  // AC-734: Handler para mudança de pasta
  handleChangeFolders = evt => {
    const { oDocument } = this.state;
    oDocument.fldr_nid = evt.target.value;
    this.setState({ oDocument });
  };

  // AC-734: Handler para mudança de normas
  handleChangeRequisites = (aValue) => {
    this.setState({ aSelectedRequisites: aValue || [] });
  };

  render() {
    const {
      oDocument,
      oVersion,
      nResponsibleId,
      nWriterId,
      nReviewerId,
      aSelectedUsers,
      aFilteredUsers,
      aSelected,
      bIsSend,
      bLoading,
      cResponsibleName,
      rcmpAlertMsg,
      bAmResponsible,
      aUsers,
      bShowWarning,
      aTeams,
      aSelectedDistribution,
      aTreeViewFolders,
      aRequisites,
      aSelectedRequisites,
      bIsPublishedVer,
    } = this.state;

    const { router, closeModal } = this.props;
    const params = router ? router.params : {};
    const cModule = 'documents';

    return (
      <PageClean loading={bLoading ? 1 : 0}>
        <div ref={this.alertWrapper} style={{ paddingTop: 5 }}>
          {rcmpAlertMsg}
        </div>
        <h2>{intl.get('DocumentEdit.documento')}</h2>

        {/* Título fixo para documentos publicados */}
        {bIsPublishedVer && (
          <header id="inactive-header">
            <div className="info">
              <p>{oDocument.doc_ctitle}</p>
            </div>
          </header>
        )}

        <Form autoComplete="off" onSubmit={this.handleSubmit} className="form">
          {/* Campos editáveis apenas para não publicados */}
          {!bIsPublishedVer && (
            <>
              <label className="colspan">
                {intl.get('Document.campo_titulo')} <span className="required">*</span>
                <Input
                  type="text"
                  name="doc_ctitle"
                  maxLength="100"
                  required
                  onChange={this.handleChangeDoc}
                  value={oDocument.doc_ctitle || ''}
                />
              </label>

              <label className="split2" htmlFor="tree-view">
                {intl.get('Document.pasta')} <span className="required">*</span>
                <TreeViewLayer
                  oFolderTree={aTreeViewFolders}
                  fnSelectFolder={this.handleChangeFolders}
                  nFolderId={oDocument.fldr_nid}
                  className="modal"
                  cHeight="180px"
                />
              </label>

              <label className="split2">
                {intl.get('Nav.normas')} <span className='norm-smalltext'>({intl.get('Document.find_and_add')})</span>
                <Select
                  onChange={this.handleChangeRequisites}
                  value={aSelectedRequisites}
                  className="selectCustom"
                  classNamePrefix="react-select"
                  noOptionsMessage={() => intl.get('Document.norma_nao_encontrada')}
                  isMulti
                  options={aRequisites}
                  placeholder=""
                />
              </label>

              <label className="split1 colspan">
                {intl.get('Document.campo_justificativa')} <span className="required">*</span>
                <Input
                  type="textarea"
                  name="ver_cjustification"
                  style={{ height: '80px' }}
                  maxLength={1280}
                  required
                  onChange={this.handleChangeVersion}
                  value={oVersion.ver_cjustification || ''}
                />
              </label>
            </>
          )}

          <div className="row-responsible-title">
            <label className="label-responsible">
              {intl.get('Document.responsibles')}<span className="required">*</span>
            </label>
            <label className="label-term">
              {intl.get('Document.term')} ({intl.get('Document.days')})<span className="required">*</span>
            </label>
          </div>

          {(can('admin', cModule) || (nReviewerId === nWriterId) || ([nWriterId, nReviewerId, nResponsibleId].includes(nUserId))) && (
            <div className="row-responsible">
              <div className="column-user-image">
                <i className="icon-editing" title={intl.get("Status.em-redacao")} />
                <div className="icon-vertical-line">&nbsp;</div>
              </div>
              <div className="column-user-responsible">
                <label>
                  {intl.get('Status.redaction')} <span className="required">*</span>
                  <Select
                    className="selectCustom"
                    classNamePrefix="react-select"
                    options={aUsers}
                    placeholder={intl.get('Document.writer_select')}
                    value={
                      nWriterId ?
                        aUsers.filter(oUserItem => {
                          return nWriterId === oUserItem.value
                        })
                        : ''
                    }
                    maxMenuHeight={150}
                    onChange={elSelectedOption => this.handleChangeDocumentResponsibles(elSelectedOption, 'nWriterId')}
                    required
                  />
                </label>
              </div>
              <div className="column-user-term">
                <DateLimitation
                  cId="doc_ntermessay"
                  cName="doc_ntermessay"
                  bIsRequired
                  nMin={0}
                  fnHandleChange={this.handleChangeDoc}
                  cValue={String(oDocument.doc_ntermessay ?? 0) || ''}
                  cDiffTime={'D'}
                />
              </div>
            </div>
          )}

          <div className="row-responsible">
            <div className="column-user-image">
              <i className="icon-comment" title={intl.get("Status.em-revisao")} />
              <div className="icon-vertical-line">&nbsp;</div>
            </div>
            <div className="column-user-responsible">
              <label>
                {intl.get('Status.review_capitalized')} <span className="required">*</span>
                <Select
                  className="selectCustom"
                  classNamePrefix="react-select"
                  options={aUsers}
                  placeholder={intl.get('Document.selecione_revisor')}
                  value={
                    nReviewerId ?
                      aUsers.filter(oUserItem => {
                        return nReviewerId === oUserItem.value
                      })
                      : ''
                  }
                  maxMenuHeight={150}
                  onChange={elSelectedOption => this.handleChangeDocumentResponsibles(elSelectedOption, 'nReviewerId')}
                  required
                />
              </label>
            </div>
            <div className="column-user-term">
              <DateLimitation
                cId="doc_ntermreview"
                cName="doc_ntermreview"
                bIsRequired
                nMin={0}
                fnHandleChange={this.handleChangeDoc}
                cValue={String(oDocument.doc_ntermreview ?? 0) || ''}
                cDiffTime={'D'}
              />
            </div>
          </div>

          {(can('admin', cModule) || ([nWriterId, nReviewerId, nResponsibleId].includes(nUserId)) || (nReviewerId === nResponsibleId)) && (
            <div className="row-responsible">
              <div className="column-user-image">
                <i className="icon-published" title={intl.get("Status.aguardando-publicacao")} />
              </div>
              <div className="column-user-responsible">
                <label>
                  {intl.get('Status.publishing_capitalized')} <span className="required">*</span>
                  {can('admin', cModule) ? (<Select
                    className="selectCustom"
                    classNamePrefix="react-select"
                    options={aUsers}
                    placeholder={intl.get('Document.responsible_select')}
                    value={
                      nResponsibleId ?
                        aUsers.filter(oUserItem => {
                          return nResponsibleId === oUserItem.value
                        })
                        : ''
                    }
                    maxMenuHeight={150}
                    onChange={elSelectedOption => this.handleChangeDocumentResponsibles(elSelectedOption, 'nResponsibleId')}
                    required
                  />)
                    : (
                      <Input
                        onChange={this.handleChange}
                        type="text"
                        value={cResponsibleName}
                        required
                        readOnly={true}
                        name="nResponsibleId"
                      />
                    )}
                </label>
              </div>
              <div className="column-user-term">
                <DateLimitation
                  cId="doc_ntermliberation"
                  cName="doc_ntermliberation"
                  bIsRequired
                  nMin={0}
                  fnHandleChange={this.handleChangeDoc}
                  cValue={String(oDocument.doc_ntermliberation ?? 0) || ''}
                  cDiffTime={'D'}
                />
              </div>
            </div>
          )}

          <label className="split1">
            {intl.get('DocumentEdit.versionamento')} &nbsp;
            <small>{intl.get('DocumentEdit.versionamento_atencao')}</small>
            <Input
              onChange={this.handleChangeDoc}
              defaultValue={oDocument.doc_eversiontype}
              type="select"
              id="select-versioning"
              name="doc_eversiontype"
              className="half2"
              disabled={bIsPublishedVer}
            >
              <option value="A">{intl.get('DocumentEdit.versionamento_automatico')}</option>
              <option value="M">{intl.get('DocumentEdit.versionamento_manual')}</option>
            </Input>
          </label>
          <label
            className="split1"
            style={{ display: oDocument.doc_eversiontype === 'M' ? 'block' : 'none' }}
            id="version-manual"
          >
            {intl.get('DocumentEdit.versao')} <span className="required">*</span>
            <Input
              onChange={this.handleChangeVersion}
              value={oVersion.ver_cnumber || ''}
              maxLength={10}
              name="ver_cnumber"
              required
              type="text"
              disabled={bIsPublishedVer}
            />
          </label>

          <label className="split1">
            <span>{intl.get('DocumentEdit.distribution')}</span>
            <Select
              className="selectCustom"
              classNamePrefix="react-select"
              noOptionsMessage={() => intl.get('DocumentEdit.team_not_found')}
              isMulti
              defaultValue={aSelectedDistribution}
              options={aTeams}
              onChange={elSelectedOption => this.handleChangeCustomMult(elSelectedOption, 'aSelectedDistribution')}
              placeholder={intl.get('DocumentEdit.select_teams')}
              maxMenuHeight={100}
            />
          </label>
          {bIsPublishedVer && (
            <div className="containerTeam">
              <label>
                <b>{intl.get('DocumentPublish.busca')}</b>
                {bShowWarning && <span className="user-message">{intl.get('DocumentEdit.remove_users_message')}</span>}
                <Input
                  type="text"
                  id="busca"
                  name="busca"
                  maxLength="250"
                  placeholder={intl.get('DocumentPublish.membros_equipe_placeholder')}
                  onChange={this.filterList}
                  onFocus={this.onFocusSearch}
                  onClick={this.onFocusSearch}
                />
                {this.renderList(_.orderBy(aFilteredUsers, [oUser => oUser.user_cname.toLowerCase()], ['asc']))}
              </label>

              <div id="selectedUsers">
                {aSelected.map(oUser => (
                  <span
                    key={oUser.user_nid ? `u-${oUser.user_nid}` : `e-${oUser.team_nid}`}
                    className={`userBox ${!oUser.user_bregistered ? 'pending' : ''}`}
                  >
                    <span
                      role="button"
                      tabIndex="0"
                      onKeyPress={() => this.removeUser(oUser)}
                      onClick={() => this.removeUser(oUser)}
                      className="removeUser"
                    >
                      {intl.get('remover')}
                    </span>
                    <img src={this.getListImageSource(oUser)} alt={oUser.user_nid !== null ? 'Usuário' : 'Equipe'} />

                    <p className="user_cname" title={oUser.user_cname}>
                      {oUser.user_cname}
                    </p>
                  </span>
                ))}
              </div>
            </div>)}

          <div className="button-stack">
            <Button
              type="button"
              onClick={!params ? () => window.history.back() : closeModal}
              className="btn btn-cancel"
            >
              {intl.get('cancel')}
            </Button>
            <Button disabled={bIsSend} name="action" type="submit" className="btn">
              {intl.get('salvar')}
            </Button>
          </div>
        </Form>
      </PageClean>
    );
  }
}

export default DocumentEdit;
